import location from "../../assets/location.svg";
import mail from "../../assets/mail.svg";

export const contactInformation = [
  {
    icon: location,
    contactInfo: "8502 Preston Rd. Inglewood, Maine 98380, USA",
  },
  {
    icon: mail,
    contactInfo: "support@fintech.co",
  },
];

export const footerLinks = [
  {
    href: "#",
    name: "About",
  },
  {
    href: "#",
    name: "Solutions",
  },
  {
    href: "#",
    name: "Pricing",
  },
  {
    href: "#",
    name: "Resources",
  },
];
